import { createSelector } from 'reselect';
import RequestStatusTypes from '../constants/RequestStatusTypes';
import { FETCH_ATTRIBUTES, UPDATE_PHONE_NUMBER, UPDATE_LANGUAGE_WITH_LOCALE, UPDATE_LOCALE_WITH_LANGUAGE, UPDATE_DEFAULT_PHONE_COUNTRY_CODE, UPDATE_DEFAULT_HOME } from '../actions/AttributeActions';
import { FETCH_EMAIL_ADDRESSES, ADD_EMAIL_ADDRESS, EDIT_EMAIL_ADDRESS, RESEND_PENDING_CONFIRMATION, CANCEL_PENDING_EMAIL_ADDRESS, REMOVE_EMAIL_ADDRESS, ADD_EMAIL, DELETE_EMAIL, RESEND_VERIFICATION, SET_PRIMARY } from '../actions/EmailAddressActions';
import { FETCH_APP_USER } from '../actions/AppUserActions';
import { FETCH_PROFILE, FETCH_IS_SCIM_USER, UPDATE_PROFILE, UPDATE_PASSWORD, RESET_PASSWORD, DELETE_SELF } from '../actions/ProfileActions';
import { FETCH_PROFILE_OPTIONS } from '../actions/ProfileOptionsActions';
import { FETCH_CAN_EDIT_USER } from '../actions/IsRestrictedImpersonateeActions';
import { NotificationActionTypes } from '../actions/NotificationActions';
import { HubUsersActionTypes } from '../actions/HubUsersActions';
import { AvatarActionTypes } from '../actions/AvatarActions';
import { TwoFactorAuthActionTypes } from '../actions/TwoFactorAuthActions';
import { SecurityPhoneNumberActionTypes } from '../actions/security/SecurityPhoneNumberActions';
import { FETCH_PORTAL_SETTING } from '../actions/PortalSettingsActions';
import { FETCH_HOME_PAGE_OPTIONS, FETCH_DEFAULT_HOME_PAGE } from '../actions/NavConfigActions';
import { StagingActionTypes } from '../actions/StagingActions';
const {
  FETCH_NOTIFICATIONS,
  UPDATE_WEEKLY_PROGRESS_REPORT_SUBSCRIPTION,
  UPDATE_MONTHLY_MARKETING_REPORT_SUBSCRIPTION,
  UPDATE_CALENDAR_NOTIFICATION,
  UPDATE_PROJECTS_NOTIFICATION,
  UPDATE_LEAD_REVISIT_NOTIFICATION,
  UPDATE_SUCCESS_NOTIFICATION,
  RESEND_MONTHLY_MARKETING_REPORT,
  RESEND_WEEKLY_PROGRESS_REPORT,
  SEND_WEEKLY_PROGRESS_REPORT,
  SEND_MONTHLY_MARKETING_REPORT
} = NotificationActionTypes;
const {
  FETCH_HUB_USERS
} = HubUsersActionTypes;
const {
  UPLOAD_AVATAR,
  REMOVE_AVATAR,
  SET_GRAVATAR
} = AvatarActionTypes;
const getRequestStatuses = state => state.requests;
export const getRequestStatus = requestType => createSelector([getRequestStatuses], requestStatuses => {
  if (requestType.indexOf('_REQUEST') > -1) {
    const parts = requestType.split('_');
    return requestStatuses.get(parts.slice(0, parts.length - 1).join('_'), RequestStatusTypes.UNINITIALIZED);
  }
  return requestStatuses.get(requestType, RequestStatusTypes.UNINITIALIZED);
});
export const getFetchAppUserRequestStatus = getRequestStatus(FETCH_APP_USER);
export const getFetchProfileRequestStatus = getRequestStatus(FETCH_PROFILE);
export const getFetchIsScimUserRequestStatus = getRequestStatus(FETCH_IS_SCIM_USER);
export const getUpdateProfileRequestStatus = getRequestStatus(UPDATE_PROFILE);
export const getFetchProfileOptionsRequestStatus = getRequestStatus(FETCH_PROFILE_OPTIONS);
export const getFetchAttributesRequestStatus = getRequestStatus(FETCH_ATTRIBUTES);
export const getFetchHomePageOptionsRequestStatus = getRequestStatus(FETCH_HOME_PAGE_OPTIONS);
export const getFetchDefaultHomePageRequestStatus = getRequestStatus(FETCH_DEFAULT_HOME_PAGE);
export const getFetchEmailAddressesRequestStatus = getRequestStatus(FETCH_EMAIL_ADDRESSES);
export const getAddEmailAddressRequestStatus = getRequestStatus(ADD_EMAIL_ADDRESS);
export const getEditEmailAddressRequestStatus = getRequestStatus(EDIT_EMAIL_ADDRESS);
export const getResendPendingConfirmationRequestStatus = getRequestStatus(RESEND_PENDING_CONFIRMATION);
export const getCancelPendingEmailAddressRequestStatus = getRequestStatus(CANCEL_PENDING_EMAIL_ADDRESS);
export const getRemoveEmailAddressRequestStatus = getRequestStatus(REMOVE_EMAIL_ADDRESS);
export const getAddEmailRequestStatus = getRequestStatus(ADD_EMAIL);
export const getDeleteEmailRequestStatus = getRequestStatus(DELETE_EMAIL);
export const getResendVerificationRequestStatus = getRequestStatus(RESEND_VERIFICATION);
export const getSetPrimaryRequestStatus = getRequestStatus(SET_PRIMARY);
export const getUpdatePasswordRequestStatus = getRequestStatus(UPDATE_PASSWORD);
export const getResetPasswordRequestStatus = getRequestStatus(RESET_PASSWORD);
export const getUpdateDefaultPhoneCountryCodeRequestStatus = getRequestStatus(UPDATE_DEFAULT_PHONE_COUNTRY_CODE);
export const getUpdatePhoneNumberRequestStatus = getRequestStatus(UPDATE_PHONE_NUMBER);
export const getUpdateLanguageRequestStatus = getRequestStatus(UPDATE_LANGUAGE_WITH_LOCALE);
export const getUpdateLocaleRequestStatus = getRequestStatus(UPDATE_LOCALE_WITH_LANGUAGE);
export const getFetchNotificationsRequestStatus = getRequestStatus(FETCH_NOTIFICATIONS);
export const getUpdateWeeklyProgressReportSubscriptionRequestStatus = getRequestStatus(UPDATE_WEEKLY_PROGRESS_REPORT_SUBSCRIPTION);
export const getUpdateMonthlyMarketingReportSubscriptionRequestStatus = getRequestStatus(UPDATE_MONTHLY_MARKETING_REPORT_SUBSCRIPTION);
export const getUpdateCalendarNotificationRequestStatus = getRequestStatus(UPDATE_CALENDAR_NOTIFICATION);
export const getUpdateSuccessNotificationRequestStatus = getRequestStatus(UPDATE_SUCCESS_NOTIFICATION);
export const getUpdateProjectsNotificationRequestStatus = getRequestStatus(UPDATE_PROJECTS_NOTIFICATION);
export const getUpdateLeadRevisitNotificationRequestStatus = getRequestStatus(UPDATE_LEAD_REVISIT_NOTIFICATION);
export const getResendMonthlyMarketingReportRequestStatus = getRequestStatus(RESEND_MONTHLY_MARKETING_REPORT);
export const getResendWeeklyProgressReportRequestStatus = getRequestStatus(RESEND_WEEKLY_PROGRESS_REPORT);
export const getFetchHubUsersRequestStatus = getRequestStatus(FETCH_HUB_USERS);
export const getFetchIsRestrictedImpersonateesRequestStatus = getRequestStatus(FETCH_CAN_EDIT_USER);
export const getSendWeeklyProgressReportRequestStatus = getRequestStatus(SEND_WEEKLY_PROGRESS_REPORT);
export const getSendMonthlyMarketingReportRequestStatus = getRequestStatus(SEND_MONTHLY_MARKETING_REPORT);
export const getUploadAvatarRequestStatus = getRequestStatus(UPLOAD_AVATAR);
export const getRemoveAvatarRequestStatus = getRequestStatus(REMOVE_AVATAR);
export const getSetGravatarRequestStatus = getRequestStatus(SET_GRAVATAR);
export const getTwoFactorConfirmedRequestStatus = getRequestStatus(TwoFactorAuthActionTypes.CONFIRMED_2FA_METHOD);
export const getTwoFactorVerificationRequestStatus = getRequestStatus(TwoFactorAuthActionTypes.CONFIRMED_VERIFICATION_CODE_REQUEST);
export const getSecurityPhoneNumberVerificationRequestStatus = getRequestStatus(SecurityPhoneNumberActionTypes.CODE_ATTEMPT_REQUEST);
export const getDeleteSelfRequestStatus = getRequestStatus(DELETE_SELF);
export const getFetchPortalSettingRequestStatus = getRequestStatus(FETCH_PORTAL_SETTING);
export const getUpdateDefaultHomeRequestStatus = getRequestStatus(UPDATE_DEFAULT_HOME);
export const getSaveStagedChangesRequestStatus = getRequestStatus(StagingActionTypes.SAVE_STAGED_CHANGES);